import { Button } from "react-migration/components/DeprecatedButton";
import classNames from "classnames";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { resetSkipTracingStore } from "../../store/store";
import { router } from "src/js/router/react-router";
import ROUTES from "src/js/router/routes";

export const ErrorPage = () => {
  const { t } = useTranslation();

  const onBackToSitesClicked = async () => {
    await router.push({ name: ROUTES.SITES });
    resetSkipTracingStore();
  };

  return (
    <div
      className={classNames("h-full", "w-full", "flex", "flex-col", "items-center", "justify-center")}
      data-testid="skip-tracing-error-page"
    >
      <div
        className={classNames(
          "flex",
          "w-20",
          "h-20",
          "border",
          "justify-center",
          "items-center",
          "rounded-full",
          "border-negative-700",
          "bg-negative-700",
          "drop-shadow-lg",
          "drop-shadow-background-content-subtle"
        )}
      >
        <i className={classNames("icon-lt-close-line", "text-6xl", "flex", "text-white")} />
      </div>
      <span className={classNames("my-4", "text-content", "font-semibold", "text-xl", "leading-7")}>
        {t("sites.skip_tracing.error.something_went_wrong")}
      </span>
      <div className={classNames("text-base", "w-[420px]", "text-center")} data-testid="extended-error-message">
        <p className="text-text-base-secondary">{t("sites.skip_tracing.error.main_error_message")}</p>

        <span className="text-text-base-secondary">
          {t("sites.skip_tracing.error.if_there_is_still_a_problem_please_contact")}
        </span>
        <a
          href="mailto: support@land.tech?subject=Skip Tracing"
          target="_blank"
          rel="noreferrer"
          className="whitespace-nowrap"
        >
          {t("sites.skip_tracing.error.customer_support")}
        </a>
      </div>
      <Button.Primary className="mt-4" onClick={onBackToSitesClicked}>
        {t("sites.skip_tracing.back_to_sites")}
      </Button.Primary>
    </div>
  );
};
